import { useRef } from "react";
import { Resizable } from "re-resizable";
import { ResizableContainerProps } from "./types";

export const ResizableContainer = (props: ResizableContainerProps) => {
	const {
		children,
		width,
		enabledSides,
		minWidth,
		maxWidth,
		handleComponent,
		handleStyles,
		onResizeStop,
	} = props;

	const isSideEnabled = (side: string) => {
		return enabledSides.includes(side);
	};

	// Elements hidden for the duration of the drag (e.g. open tooltips/popovers that would
	// otherwise render in a stale position). Tracked so they can be restored in onResizeStop.
	// `img` is excluded - Fluent UI's Avatar sets role="presentation" on its underlying <img>,
	// so without the exclusion every contact/agent profile picture matched too and got hidden
	// for the whole duration of the drag.
	const hiddenElements = useRef<Set<HTMLElement>>(new Set());

	const onResize = (
		_event: any,
		_direction: any,
		_refToElement: any,
		_delta: any
	) => {
		document
			.querySelectorAll('[role="presentation"]:not(img)')
			.forEach((element) => {
				let htmlElement = element as HTMLElement;
				htmlElement.style.display = "none";
				hiddenElements.current.add(htmlElement);
			});
	};

	const handleResizeStop = (
		event: any,
		direction: any,
		refToElement: any,
		delta: any
	) => {
		hiddenElements.current.forEach((element) => {
			element.style.display = "";
		});
		hiddenElements.current.clear();

		onResizeStop(event, direction, refToElement, delta);
	};

	return (
		<Resizable
			size={{ width: width }}
			enable={{
				top: isSideEnabled("top"),
				right: isSideEnabled("right"),
				bottom: isSideEnabled("bottom"),
				left: isSideEnabled("left"),
				topRight: isSideEnabled("topRight"),
				bottomRight: isSideEnabled("bottomRight"),
				bottomLeft: isSideEnabled("bottomLeft"),
				topLeft: isSideEnabled("topLeft"),
			}}
			minWidth={minWidth}
			maxWidth={maxWidth}
			handleComponent={handleComponent}
			handleStyles={handleStyles}
			onResize={onResize}
			onResizeStop={handleResizeStop}
			style={{ zIndex: 3 }}
		>
			{children}
		</Resizable>
	);
};
